import SupportBanner from 'components/tailgrids-ui/support-banner';
import React from 'react';

function SupportBannerTastic({ data }) {
  return <SupportBanner {...data} />;
}

export default SupportBannerTastic;
